<h4>
    <b [style.font-size]="'500%'" [style.color]="'#fb6227'">
      {{word[0]}}
    </b>
    stands for
    <b [style.color]="'#fb6227'"> {{word}}</b>
  </h4>
